import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { UnstyledButton } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines, faSpinner, faTrash } from "@fortawesome/pro-regular-svg-icons";
import { formatFileName } from "@/utils/format";
/** Shows an attached file or letter with a remove control. */
export function FileCard(_ref) {
  var fileName = _ref.fileName,
    s3Key = _ref.s3Key,
    sourceLabel = _ref.sourceLabel,
    onDelete = _ref.onDelete,
    isDeleting = _ref.isDeleting,
    testId = _ref.testId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var displayName = fileName || formatFileName(s3Key) || s3Key;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between gap-3 rounded-sds-200 border border-sds-success-default bg-sds-success-tertiary p-3"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex min-w-0 items-center gap-3"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-sds-200 bg-sds-success-secondary"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faFileLines,
    className: "h-6 w-6 text-sds-success-on-success-secondary"
  })), /*#__PURE__*/React.createElement("span", {
    className: "flex min-w-0 flex-col"
  }, /*#__PURE__*/React.createElement("span", {
    title: displayName,
    className: "truncate text-style-body-small-strong text-sds-base-default"
  }, displayName), /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-base text-sds-success-default"
  }, sourceLabel))), /*#__PURE__*/React.createElement(UnstyledButton, {
    type: "button",
    "data-testid": testId,
    "aria-label": t("remove", {
      defaultValue: "Remove"
    }),
    onClick: onDelete,
    disabled: isDeleting,
    className: "flex-shrink-0 text-sds-base-tertiary hover:text-sds-urgent-secondary"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: isDeleting ? faSpinner : faTrash,
    spin: isDeleting,
    className: "h-5 w-5"
  })));
}